
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Home',
  emits: ['updateUserInfo'],
  props: ['userInfo'],
  components: {},
});
